<template>
<el-checkbox-group v-model="modValue" v-bind="props" @change="change">
  <el-checkbox
    v-for="option in options"
    :key="option.value"
    :label="option.value"
    :style="{'margin-right': '16px'}"
  >
    {{ option.label }}
  </el-checkbox>
</el-checkbox-group>
</template>

<script>
export default {
  name: 'CheckboxGroup',
  props: ['value', 'widget', 'verifyInfo', 'rules'],
  data() {
    return {
      modValue: this.value || [],
    };
  },
  computed: {
    props () {
      return this.widget.props;
    },
    options () {
      return this.widget.props.options;
    },
  },
  watch: {
    value() {
      this.modValue = this.value;
    },
  },
  methods: {
    change() {
      setTimeout(() => {
        this.$emit('change', this.modValue);
      }, 15);
    },
  },
};
</script>

<style>

</style>
